
import { useState, useMemo, useEffect, useCallback, useContext, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { filterRows } from '../helpers'
import Pagination from '../Pagination'
import CompanyLogo from '../CompanyLogo';
import SortIcon from 'mdi-react/SortIcon'
import SortAscendingIcon from 'mdi-react/SortAscendingIcon'
import SortDescendingIcon from 'mdi-react/SortDescendingIcon'
import '../TableView.css'
import { routeNames } from '../../routeSegments';
import RandomLogo from '../RandomLogo';
import OverflowToolTip from '../shared/OverflowToolTip';
import { mostActiveAcquirers } from '../../Config/config'
import { TableDataContext } from '../../Contexts/TableDataContext'
import axios from "axios";
import NoDataPlaceholder from '../shared/NoDataPlaceholder';
import Loader from '../Loader';
import { UserContext } from '../../Contexts/UserContext';
import Constants from '../../Constants';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import moment from "moment";


/**
 * The `Table` component is a JavaScript function that renders a table based on the provided columns,
 * menu, month, order, and orderBy parameters.
 * @returns The `Table` component is being returned.
 */
const Table = ({ columns, menu, month, order, orderBy, sub_type_master_id }) => {

  const { rows, setRows, data, setData, isLoad, setIsLoad, setIsDataLoad, setTotalNoOfCompanies, setTableAcquirerId, currentPage, setCurrentPage, setCurrentFilter, setAllDealIds } = useContext(TableDataContext);
  const { monthPickerValue, setIsMonthPickerChanged, setIsTagClosed, refineSearchFilters, groupId, accessControl } = useContext(PeFilterContext);
  const [filters] = useState({})
  const [sort, setSort] = useState({ order: order, orderBy: orderBy })
  const { getToken, logout } = useContext(UserContext);
  const abortRef = useRef(null)
  const location = useLocation();

  const findActivePage = (page) => {
    setCurrentPage(page)
    tableRender(page, monthPickerValue, sort.orderBy, sort.order, groupId)
    setIsLoad(true)
  }

  const tableRender = useCallback((page, month, column, order) => {
    setIsTagClosed(0)
    setIsMonthPickerChanged(0)
    axios(`${mostActiveAcquirers}`, {
      method: "POST",
      signal: abortRef.current.signal,
      data: {
        date_range: {
          from_date: moment(month[0]).format("YYYY-MM-DD"),
          to_date: moment(month[1]).format("YYYY-MM-DD"),
        },
        "order_by": {
          "column": column,
          "direction": order
        },
        "page": page,
        acquirer_group: refineSearchFilters[location.pathname]?.acquirer_group?.map(opt => opt.name),
        "acquirer_city": refineSearchFilters[location.pathname]?.acquirerCity?.map(city => city.id),
        "acquirer_ids": refineSearchFilters[location.pathname]?.acquirers?.map(acq => acq.id),
        "acquirer_company_type": refineSearchFilters[location.pathname]?.acquirerType?.map(type => type.id),
        "acquirer_country": refineSearchFilters[location.pathname]?.acquirerCountries?.map(city => city.id),
        "company_group": refineSearchFilters[location.pathname]?.group?.map(group => group.name),
        "acquirer_region": refineSearchFilters[location.pathname]?.acquirerRegion?.map(city => city.id),
        "acquirer_state": refineSearchFilters[location.pathname]?.acquirerState?.map(city => city.id),
        "deal_range": refineSearchFilters[location.pathname]?.dealRange?.at(0) && {
          "from": refineSearchFilters[location.pathname]?.dealRange[0].name,
          "to": refineSearchFilters[location.pathname]?.dealRange[1].name
        },
        "deal_type": refineSearchFilters[location.pathname]?.dealType?.map(type => type.id),
        "ladvisor_ids": refineSearchFilters[location.pathname]?.ladvisors?.map(acq => acq.id),
        "tadvisor_ids": refineSearchFilters[location.pathname]?.tadvisors?.map(acq => acq.id),
        "target_city": refineSearchFilters[location.pathname]?.city?.length > 0 ? refineSearchFilters[location.pathname]?.city?.map(
          (city) => city.id
        ) : accessControl?.ma_cities?.id,
        "target_company_type": refineSearchFilters[location.pathname]?.companyType?.map(type => type.id),
        "target_country": refineSearchFilters[location.pathname]?.countries?.length > 0 ? refineSearchFilters[location.pathname]?.countries?.map(country => country.id) : accessControl?.ma_countries?.id,
        "target_industry": refineSearchFilters[location.pathname]?.industry?.length > 0 ? refineSearchFilters[location.pathname]?.industry?.map(
          (value) => value.id) : accessControl?.maindustries?.id,
        "acquirer_industry": refineSearchFilters[location.pathname]?.acquirer_industry?.length > 0 ? refineSearchFilters[location.pathname]?.acquirer_industry?.map(
          (value) => value.id) : accessControl?.maindustries?.id,
        "target_sector": refineSearchFilters[location.pathname]?.sector?.map(value => value.name),
        "target_region": refineSearchFilters[location.pathname]?.region?.length > 0 ? refineSearchFilters[location.pathname]?.region?.map(
          (region) => region.id
        ) : accessControl?.ma_regions?.id,
        "target_state": refineSearchFilters[location.pathname]?.state?.length > 0 ? refineSearchFilters[location.pathname]?.state?.map(
          (state) => state.id
        ) : accessControl?.ma_states?.id,
        "valuation": refineSearchFilters[location.pathname]?.valuations?.map(valuation => valuation.value),
        group: {
          group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null,
          sub_type_master_id: groupId?.myList?.length > 0 ? sub_type_master_id : null
        }
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken()
      },

    })
      .then((response) => {
        if (response?.data?.message === "Success") {
          setCurrentFilter(response.config.data)
          setTotalNoOfCompanies(response?.data?.num_acquirers)
          setIsLoad(false)
          setIsDataLoad(false)
          setRows([])
          setRows(response?.data?.companies)
          setData(response?.data)
          setTableAcquirerId(response?.data?.all_acquirer_ids)
          setAllDealIds(response?.data?.all_deal_ids)
        }
      })
      .catch((error) => {
        if (error?.response?.status === Constants.sessionTerminatedStatus
          || error?.response?.status === Constants.InvalidTokenStatus
        ) {
          logout();
        }
        console.log("API not working", error);
      });
  }, [setIsTagClosed, setIsMonthPickerChanged, refineSearchFilters, location.pathname, accessControl, groupId, sub_type_master_id, getToken, setCurrentFilter, setTotalNoOfCompanies, setIsLoad, setIsDataLoad, setRows, setData, setTableAcquirerId, setAllDealIds, logout]);


  useEffect(() => {
    const abortController = new AbortController()
    abortRef.current = abortController;
    setIsLoad(true)
    setIsDataLoad(true)
    setCurrentPage(currentPage);
    tableRender(currentPage, monthPickerValue, sort.orderBy, sort.order, groupId)
    return () => {
      abortController.abort();
    }
  }, [tableRender, monthPickerValue, groupId, refineSearchFilters, currentPage, setCurrentPage, setIsDataLoad, setIsLoad, sort.orderBy, sort.order]);


  const filteredRows = useMemo(() => filterRows(rows, filters), [rows, filters])

  const handleSort = (accessor) => {
    setCurrentPage(currentPage);
    setRows([]);
    setIsLoad(true);
    setIsDataLoad(true);

    const isNumericColumn = ["acquisitions"].includes(accessor);

    setSort((prevSort) => {
      const isSameColumn = prevSort.orderBy === accessor;
      const newOrder = isSameColumn
        ? prevSort.order === 'desc' ? 'asc' : 'desc'
        : isNumericColumn ? 'desc' : 'asc';

      tableRender(currentPage, monthPickerValue, accessor, newOrder, groupId);

      return {
        order: newOrder,
        orderBy: accessor,
      };
    });
  };

  const count = filteredRows.length

  const addCommasToNumber = (number) => {
    return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const onNumClick = (initialSearch, dateRange) => {
    const data = {
      initialSearch,
      dateRange,
    }
    localStorage.setItem(Constants.localStorageKeys.referer, JSON.stringify(data))
  }

  const getSearch = (ids, acquirer, acquirerId) => {
    return {
      companyIds: [
        {
          value: ids,
          acquirerId,
          name: "Most Active Acquirer - " + acquirer,
        }
      ]
    }
  }

  return (
    <>
      <div className="md:col-span-4 col-span-5">
        <div className="lg:col-span-4">
          <div className="scrollbar ">
            <div className={"overflow-x-auto scrollbar rounded-b-[6px] " + (rows.length > 5 ? '' : 'pr-2')}>
              <table className="listPage table w-full p-1 bg-grey-50 divide-y" width="50%">
                <thead className="bg-[#EBEBEB] text-[11pt] leading-[16pt] lg:text-[13px] lg:leading-[15px] font-semibold text-[#666666]  text-left">
                  <tr>
                    {columns.map((column, i) => {
                      const sortIcon = () => {
                        if (column.accessor === sort.orderBy) {
                          if (sort.order === 'asc') {
                            return <SortDescendingIcon className="pl-2 block h-[15px]" />
                          }
                          return <SortAscendingIcon className="pl-2 block h-[15px]" />
                        } else {
                          return <SortIcon className="pl-2 block h-[15px] " />
                        }
                      }
                      return (
                        <th className={i === 0 ? "md:pl-5 md:pr-5 pl-5 pr-[9rem] w-[20%]" : "px-5 py-2 font-sans_book_body w-[10%]"} key={i}>
                          <span className="flex whitespace-nowrap">
                            {column.label}
                            <button onClick={() => handleSort(column.accessor, sort.order)}>
                              {sortIcon()}
                            </button>
                          </span>
                        </th>
                      )
                    })}
                    <th></th>
                  </tr>
                </thead>
                {!isLoad ?
                  count > 0 ?
                    <tbody className="text-[11pt] w-full leading-[16pt] lg:text-[.875rem] lg:leading-[1rem] font-sans_book_body text-[#333333] text-left">
                      {rows?.length > 0 ? (
                        rows.map((row, i) => (
                          <tr
                            key={i}
                            className="group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF] border-b bg-white"
                          >
                            <td className="leading-[32px] px-5 py-3 font-sans_book_body card-animate w-[25%]">
                              <div className="flex items-center">
                                {row?.logoPath === "default.png" ||
                                  row?.logoPath === "/default.png" ||
                                  !row?.logoPath ? (
                                  <RandomLogo name={row?.acquirer_name} />
                                ) : (
                                  <CompanyLogo
                                    name={row?.acquirer_name}
                                    id={row?.acquirer_id}
                                    page="company page"
                                    logo={row?.logoPath}
                                  />
                                )}

                                <OverflowToolTip
                                  component={
                                    row?.acquirer_name === "PE Firm(s)" ? (
                                      <span className="flex text-start lg:inline leading-[1.1rem] whitespace-normal break-words font-medium">
                                        {row.acquirer_name}
                                      </span>
                                    ) : (
                                      <NavLink
                                        state={{ prevPath: location.pathname }}
                                        to={routeNames.maAcquiresById(row.acquirer_id)}
                                        className="hover:text-[#BC8B20]"
                                      >
                                        {row.acquirer_name ? row.acquirer_name : "--"}
                                      </NavLink>
                                    )
                                  }
                                />
                              </div>
                            </td>

                            <td className="pr-11 2xl:pr-[52.8px] py-3 font-sans_book_body text-right w-[10%] hover:underline font-semibold text-[#567EBA] cursor-pointer">
                              {row.acquisitions && row.acquisitions !== 0 ? (
                                <NavLink
                                  onClick={() =>
                                    onNumClick(
                                      getSearch(row.company_ids, row.acquirer_name, row.acquirer_id),
                                      monthPickerValue,
                                      routeNames.ma_companies
                                    )
                                  }
                                  target="_blank"
                                  to={routeNames.ma_companies}
                                >
                                  {addCommasToNumber(row.acquisitions)}
                                </NavLink>
                              ) : (
                                "--"
                              )}
                            </td>

                            <td></td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center py-6 text-[12pt] text-[#333333]">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    : <></>
                  : <></>
                }
              </table>

              {!isLoad ?
                count > 0 ?
                  <></>
                  : <div className='pr-2'>
                    <div className='w-full h-[17rem] bg-white flex items-center justify-center fixed md:relative'>
                      <NoDataPlaceholder />
                    </div>
                  </div>
                :
                <div className='w-full h-[17rem] bg-white flex items-center justify-center absolute md:relative'>
                  <Loader />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      {data?.num_acquirers && rows.length > 0 ? (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={data?.num_acquirers}
          pageSize={20}
          onPageChange={(page) => findActivePage(page)}
        />
      ) : (
        ""
      )}
    </>
  )
}

export default Table
